// extracted by mini-css-extract-plugin
export default {"button":"I6ZUgVU7","button_column":"qaXdMahX","button_row":"JSz0pTX7"};